// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__2zJNI","statement":"styles_statement__3t8FL"};